import React, { useCallback, useEffect, useState } from 'react';
import TotalTable from './TotalTable';
import TotalCharts from './TotalCharts';
import moment from 'moment';
import { arrayToSimpleObj, getTimeSpaceArray } from '@/pages/opinion/utils';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { getTrendsTotalHeatInfo } from '@/pages/opinion/services/trends';
import { useIntl } from 'umi';
import { downloadAction } from '@/pages/opinion/components/DownloadCommon/download-page';
import { barIcon, lineIcon, tableIcon } from '@/pages/opinion/constants/chart';

function dealWithTotalHeatData(
  data: {
    now: Array<{ date: string; total_hot_index_number: number }>;
    old: Array<{ date: string; total_hot_index_number: number }>;
  },
  start_time: string,
  end_time: string,
) {
  let result: any = {};
  let dateList = getTimeSpaceArray(start_time, end_time);
  try {
    let nowObj: any = {};
    let oldObj: any = {};
    if (data.now) {
      nowObj = arrayToSimpleObj(data.now, 'total_hot_index_number', 'date');
    }
    if (data.old) {
      oldObj = arrayToSimpleObj(data.old, 'total_hot_index_number', 'date');
    }
    dateList.forEach((item) => {
      let oldKey = moment(item).subtract(7, 'days').format('YYYY-MM-DD');
      result[item] = {
        today: nowObj[item] || 0,
        lastWeek: oldObj[oldKey] || 0,
        date: item,
      };
    });
  } catch (error) {
    console.log(error);
  }
  return Object.values(result);
}

export default function TotalHeatCard({
  params,
  wholeGameInfo,
}: {
  params: any;
  wholeGameInfo: any;
}) {
  const [originalData, setOriginalData] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);
  const { formatMessage } = useIntl();

  const download = () => {
    const downloadLimit = 150000; //下载限制条数
    const gameName = wholeGameInfo?.entity_name || '';
    const fileName = `Opinions_${gameName}_Trends_Total_Heat_${moment(
      params.start_time,
    ).format('YYYYMMDD')}_${moment(params.end_time).format('YYYYMMDD')}`;
    downloadAction({
      limit: downloadLimit,
      fileName,
      downLoadParams: params,
      downloadFunc: 'getTrendsTotalHeatDownload',
    });
  };

  useEffect(() => {
    if (!params.region) {
      return;
    }
    setLoading(true);
    getTrendsTotalHeatInfo(params)
      .then((data: any) => {
        setOriginalData(
          dealWithTotalHeatData(data, params.start_time, params.end_time),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);

  const [type, setType] = useState<'bar' | 'table' | 'line'>('line');
  const ChartElement = useCallback(
    (type: 'bar' | 'table' | 'line') => {
      const Component = type === 'table' ? TotalTable : TotalCharts;
      return (
        <Component
          dateType={params?.date_type}
          type={type}
          originalData={originalData}
        ></Component>
      );
    },
    [originalData],
  );

  return (
    <CardCommon
      title={formatMessage({ id: 'Trends of Total Heat' })}
      operations={[lineIcon, barIcon, tableIcon]}
      loading={loading}
      hasDownload
      handleDownloadOnClick={download}
      loadingHeight={312}
      emptyHeight={312}
      bodyStyle={{ height: 380 }}
      handleOperationsOnClick={(item: any) => setType(item.symbol)}
      empty={originalData?.length === 0}
    >
      {ChartElement(type)}
    </CardCommon>
  );
}
